export default class LatLng {

  public latitude = 0
  public longitude = 0
}
